/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Badge, Box, BoxProps, Text } from '@chakra-ui/react';
import { VisitData } from 'types';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';
// eslint-disable-next-line import/no-duplicates
import { format } from 'date-fns';
import { InfoBlock } from 'components';

interface Props extends BoxProps {
  visit?: VisitData;
}

export const VisitInfo: React.FC<Props> = ({ visit }) => {
  if (visit) {
    const { company, date, employee, services } = visit;
    const { address, name: companyName, type } = company;
    const visitDate =
      date &&
      format(new Date(date), 'd MMMM yyyy в HH:mm', {
        locale: ru,
      });

    return (
      <Box
        display="flex"
        flexDirection={{ base: 'column', sm: 'row' }}
        justifyContent="center"
        alignItems={{ sm: 'center' }}
        width="100%"
        gridGap={4}
        marginBottom={{ base: '96px', sm: '120px' }}
      >
        {!employee && company && <InfoBlock {...company}>{type}</InfoBlock>}
        {employee && <InfoBlock {...employee}>{employee.position}</InfoBlock>}
        <Text
          color="grayText"
          textStyle="body1"
          pl={{ sm: '4' }}
          pt={{ base: '4', sm: 0 }}
          borderColor="grayBorder"
          borderLeftWidth={{ sm: '1px' }}
          borderTopWidth={{ base: '1px', sm: 0 }}
          maxW={{ sm: 250 }}
        >
          {employee && (
            <>
              {companyName} <br />
            </>
          )}
          {address} <br />
          {visitDate && (
            <>
              {visitDate} <br />
            </>
          )}
          {services?.map(({ name }) => (
            <Badge
              key={name}
              mt={2}
              mr={3}
              borderRadius="8px"
              color="grayText"
              textStyle="body2"
              textTransform="none"
              fontWeight="normal"
            >
              {name}
            </Badge>
          ))}
        </Text>
      </Box>
    );
  }

  return null;
};
